module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADlSURBVCiRhZLRTcQwEESfU0E6IB1wdHAlUEI6uFBBRAWmg6MEOkBUEKggUMFdB4+ftbCsXBjJH56dHcu7AxXUQc3q4h9WdVZ7tqBO6iWEWR3j5OAv6tg2jeE+N68fqnsOzVSIPtxyY3ZWzw03h3bogBNASulp8w8VUkrPwBU4dcAIvPzXVOENOHbAAPzcEG1N8gs4dDvOH8BRfVeHttgBn8B9W0gpvQIPcV2qCd8B32XM687LqI8lADHVuezrUu9wx6CEoS/EFMvNO01zaMa2MFbRaiO3Bj/dcu3Dea1CvkTzUGt/AYwyD+oqT4lFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/TimeCircle.png
// module id = Syah
// module chunks = 1